import { ComponentProps, forwardRef } from "react";
import classNames from "classnames";
import styles from "./TextInput.module.scss";

type TextInputProps = ComponentProps<"input">;

// The bare native input rendered inside InputCore's content area. Owns typography only and
// removes native chrome (border/background/outline) — InputCore owns the visual box.
const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
	({ type = "text", className, ...props }, ref) => {
		return (
			<input
				ref={ref}
				type={type}
				className={classNames(styles["text-input"], className)}
				{...props}
			/>
		);
	}
);

TextInput.displayName = "TextInput";

export { TextInput };
